import React, { useState } from 'react';

export default function Tabs({ mode, onTabClick }) {
    const [activeTab, setActive] = useState(mode);

    const handler = (e) => {
        setActive(e.target.value);
        onTabClick(e.target.value);
    }

    return (
        <div className="tabs">
            <button className={"tablinks" + (activeTab === 'EnhancedData' ? ' tab-active' : '')} value='EnhancedData' onClick={(e) => handler(e)}>Data</button>
            <button className={"tablinks" + (activeTab === 'Adasis' ? ' tab-active' : '')} value='Adasis' onClick={(e) => handler(e)}>ADASIS</button>
        </div>
    );
}